<ng-container [ngSwitch]="elementType">
	<ng-container *ngSwitchCase="'desktop'">
		<mat-form-field>
			<mat-select
				[formControl]="control"
				[placeholder]="placeholder"
				(keydown.tab)="keydownTab.emit()"
				(keyup.tab)="keyupTab.emit()"
				(keydown.shift.tab)="keydownShiftTab.emit()"
				(keyup.shift.tab)="keyupShiftTab.emit()"
				(focus)="focused.emit(true)"
				(blur)="focused.emit(false)"
				(openedChange)="openedChange.emit($event)"
				(selectionChange)="valueChange.emit()"
				[required]="isRequired"
			>
				<mat-option
					*ngFor="let option of options; trackBy: trackByValue"
					[value]="option.value"
					[attr.test-id]="option.testId"
					[attr.data-test-id]="option.testId"
				>
					{{ option.name }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</ng-container>

	<ng-container *ngSwitchCase="'mobile'">
		<mat-form-field [class.disabled]="isDisabled" [appearance]="appearance">
			<mat-label>{{ placeholder }}</mat-label>
			<select
				matNativeControl
				[formControl]="control"
				(keydown.tab)="keydownTab.emit()"
				(keyup.tab)="keyupTab.emit()"
				(keydown.shift.tab)="keydownShiftTab.emit()"
				(keyup.shift.tab)="keyupShiftTab.emit()"
				(focus)="focused.emit(true)"
				(blur)="focused.emit(false)"
				(change)="valueChange.emit()"
				[required]="isRequired"
			>
				<option *ngIf="isRequired && !control?.valid" value hidden></option>
				<option
					*ngFor="let option of options; trackBy: trackByValue"
					[ngValue]="option.value"
					[attr.test-id]="option.testId"
					[attr.data-test-id]="option.testId"
				>
					{{ option.name }}
				</option>
			</select>
		</mat-form-field>
	</ng-container>

	<ng-container *ngSwitchCase="'mobileV2'">
		<mat-form-field [class.disabled]="isDisabled" [appearance]="appearance">
			<mat-label>{{ placeholder }}</mat-label>
			<mat-select
				[formControl]="control"
				(keydown.tab)="keydownTab.emit()"
				(keyup.tab)="keyupTab.emit()"
				(keydown.shift.tab)="keydownShiftTab.emit()"
				(keyup.shift.tab)="keyupShiftTab.emit()"
				(focus)="focused.emit(true)"
				(blur)="focused.emit(false)"
				(change)="valueChange.emit()"
				[required]="isRequired"
			>
				<mat-option
					*ngFor="let option of options; trackBy: trackByValue"
					[value]="option.value"
					[attr.test-id]="option.testId"
					[attr.data-test-id]="option.testId"
				>
					{{ option.name }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</ng-container>
</ng-container>
